import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";
import { _sizeHeading, _sizeText } from "../../core/core";
import "./TwoText.css";

export const TwoText = ({ block, ...props }: { block: any }) => {
  console.log(block);

  return (
    <div className={"two-text "}>
      <Title type={_sizeHeading.h2}>{block.title}</Title>
      {block.cards && (
        <div className="two-text-body">
          {block.cards.map((card: any, index: number) => (
            <div key={index} className="u-card">
              <Title type={_sizeHeading.h3}>{card.title}</Title>
              <Text size={_sizeText.m}>{card.text}</Text>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
